import { observer } from 'mobx-react';
import * as React from 'react';
import { Card, RadioList } from 'ui-toolkit';
import { propertyTaxSummaryOptions } from '../../documentTypes';

interface IProps {
  data: string;
  error?: any;
  title?: string;
  onFormChange: (dataPath: string, newData: any, error?: string | null | undefined) => void;
}

export const PropertyTaxSummary = observer(class PropertyTaxSummary extends React.Component<IProps, {}> {
  public static defaultProps: Partial<IProps> = {
    title: 'Property Tax Summary',
  };

  public render() {
    return (
      <Card title={this.props.title}>
        <div className="card--row">
          <RadioList
            className="card--row-element"
            label="Choose one"
            errorText={this.props.error[`summary.propertyTaxSummary`]}
            name="property-tax-summary"
            orientation="vertical"
            onChange={(event: any) => this.props.onFormChange('summary.propertyTaxSummary', event.target.value)}
            options={propertyTaxSummaryOptions}
            value={this.props.data}
            isRequired
          />
        </div>
      </Card>
    );
  }
});
